<template>
    <div class="home">
        <div class="top">            
            <div class="product-list">
                <div class="list-element" v-for="(element, ind) in ulist" :key="ind">
                    <h2 class="element-title">
                        <img :src="element.logo" alt="">
                        <span v-text="element.name"></span>
                    </h2>
                    <div class="info">
                        <div class="caption">Amount(₹)</div>
                        <div class="amount" v-text="element.amount"></div>
                        <div class="other-info">
                            <div class="oi-left">
                                <div class="left-text">
                                    <span class="left">Tenure:</span>
                                    <span class="right">91~180-Days</span>
                                </div>
                                <!-- <div class="left-text">
                                    <span class="left">Interest:</span>
                                    <span class="right" v-text="`  ${element.interest}`"></span>
                                </div> -->
                            </div>
                            <div class="oi-right">

                                <a @click="undway_apply(element.orderId, element.orderState)"  href="javascript:void(0);" class="btn-apply active" v-text="element.fullButtonName"></a>
                                <!-- <a href="javascript:void(0);" v-else class="btn-apply" v-text="element.isFull == 0 ?'Apply': 'Fulled'" ></a> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list-element" v-for="(element, ind) in list" :key="ind">
                    <h2 class="element-title">
                        <img :src="element.logo" alt="">
                        <span v-text="element.name"></span>
                    </h2>
                    <div class="info">
                        <div class="caption">Max Amount(₹)</div>
                        <div class="amount" v-text="element.maxAmount"></div>
                        <div class="other-info">
                            <div class="oi-left">
                                <div class="left-text">
                                    <span class="left">Tenure:</span>
                                    <!-- <span class="right" v-text="element.period + 'days'">91~180 days</span> -->
                                    <span class="right">&nbsp;91~180 days</span>
                                </div>
                                <div class="left-text">
                                    <span class="left">Interest:</span>
                                    <span class="right" v-text="` ${element.rate}%`"></span>
                                </div>
                            </div>
                            <div class="oi-right">                                
                                <a v-if="element.isFull == 0" @click="before_apply(element)" href="javascript:void(0);" class="btn-apply active" v-text="element.isFull == 0 ?'Apply': 'Fulled'"></a>
                                <a href="javascript:void(0);" v-else class="btn-apply" v-text="element.isFull == 0 ?'Apply': 'Fulled'" ></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                        
        </div>                
    </div>
</template>
<style lang="less" scoped>
    @import "~assets/less/icon.less";
    .top{
        padding:50px 35px;
        .product-list{
            .list-element{
                border-radius: 16px;
                overflow:hidden;
                margin-bottom: 50px;
                box-shadow: 0px 22px 80px 0px rgba(0,0,0,0.0800);                
                .element-title{
                    padding:0 50px;
                    width: 640px;
                    height:85px;
                    line-height: 65px;
                    display: flex;
                    align-items: center;
                    background:#52C9CF;                    
                    img{
                        width: 64px;
                        height: 64px;
                        margin-right: 50px;
                    }
                    span{
                        color:#fff;
                        font-size: 30px;
                    }
                }
                .info{
                    padding: 30px 50px;
                    .caption{
                        font-size: 32px;
                        color:#8A82A1;
                        text-align:center;
                        margin-bottom: 30px;
                    }
                    .amount{
                        font-size: 96px;
                        color:#000;
                        text-align: center;
                        font-weight: 700;
                    }
                    .other-info{
                        overflow: hidden;
                        display: flex;     
                        align-items: center;
                        .oi-left{                            
                            width: 70%;
                            .left-text{
                                .left{
                                    font-size: 30px;
                                    color:#160544;
                                }
                                .right{
                                    color:#A59BB3;
                                    font-size: 30px;                                    
                                }
                            }
                        }
                        .oi-right{
                            .btn-apply{
                                display:block;
                                width: 170px;
                                height: 60px;
                                line-height: 60px;
                                color:#fff;
                                font-size: 26px;
                                text-align:center;
                                background:#A59BB3;
                                border-radius: 6px;
                                &.active{
                                    background:#52C9CF
                                }
                            }
                        }
                        
                    }
                }
            }
        }
    }
</style>
<script>

import {useRouter} from 'vue-router'
export default {    
    props:{
        imgList:{
            type:Array,
            default:()=>{}
        },
        money: String ,
        logined: String,
        list: {
            type:Array,
            default:()=>{}
        },
        ulist:{
            type:Array,
            default:()=>{}
        }
    },
    setup() {
        const router = useRouter()
        const undway_apply = (id,orderState) => {
            if(['1'].indexOf(orderState) != -1 ) {
                router.push({
                    path:`/orders/${id}/audit`
                })
            } else if ( orderState == '2' ) {
                router.push({
                    path:`/orders/${id}/confirm`
                })                
            } else if (orderState == '6' || orderState == '8') {
                router.push({
                    path:`/orders/${id}/detail`
                })
            } else {
                router.push({
                    path:'/orders'
                })
            }    
            
        }
        const before_apply = (element) => {    
            let u = navigator.userAgent;
            let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);       
            if(isIOS) {
                window.location.href = "https://h5.creditchakr.com/"
                return
            }   
            if(element.productType == 0) {
                window.location.href = element.h5Href
            } else {
                router.push({
                    "path":'/auth/index',
                    "query":{
                        "pid":element.id
                    }
                })
            }              
            
        }
        return {
            before_apply,undway_apply
        }
        // money = ref('')
        // const money = props.money
    
        // return {
        //     money
        // }
    }    
}
</script>